import { SEARCH_REQUESTED, SEARCH_SUCCESS, SEARCH_ERROR } from "actions/const";
import config from "config";

function reducer(state = config.state.search, action) {
  switch (action.type) {
    case SEARCH_REQUESTED:
      const loading = action.updateType === "replace" ? { loading: true } : {};

      return { ...state, ...loading };

    case SEARCH_SUCCESS:
      return { ...state, loading: false, error: false };

    case SEARCH_ERROR:
      return { ...state, error: true, loading: false };

    default:
      return state;
  }
}
export default reducer;
